import { useTranslation, withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  connectSiteState,
  isEditState,
  naverAuthorizeUrl,
  popState,
  userIdState,
  userNicknameState,
  writingTypeState
} from "../../../../../atoms/atom";
import {
  checkPosition,
  loginKey,
  msgRedirectURL,
  naverAuthorizePopUp
} from "../../../../../utils/CommonFunc";
import {
  NAVER_SIGN_IN_URL,
  SIGN_IN_URL
} from "../../../../../utils/config/Config";
import "../PageRight.scss";
import { isLauncherState, loginState } from "../../../../../atoms/userInfoAtom";

interface IProps {
  type: string;
}

function CommonInput(props: IProps) {
  const { t } = useTranslation();
  const isLogin = useRecoilValue(loginState);
  const { type } = props;
  const userId = useRecoilValue(userIdState);
  const userNickname = useRecoilValue(userNicknameState);
  const setPopOpen = useSetRecoilState(popState);
  const setWritingType = useSetRecoilState(writingTypeState);
  const setIsEdit = useSetRecoilState(isEditState);
  const naverAuthorize = useRecoilValue(naverAuthorizeUrl);
  const connectSite = useRecoilValue(connectSiteState);
  const { service_code } = useParams();
  const isLauncher = useRecoilValue(isLauncherState);

  const openModal = () => {
    setPopOpen(true);
    setWritingType(type);
    setIsEdit(false);
  };

  const checkLogin = () => {
    if (isLogin === false) {
      if (isLauncher) {
        window.app.vfunRequestLogin();
      } else {
        msgRedirectURL(
          t(loginKey),
          connectSite === "vfun"
            ? SIGN_IN_URL(service_code || "vfun")
            : NAVER_SIGN_IN_URL + service_code,
          "_self"
        );
      }
    }
  };

  const naverAuthorizeCheck = () => {
    checkPosition();
    naverAuthorizePopUp(naverAuthorize);
  };

  return isLogin === false && type === "login" ? (
    <div className="top-comment">
      {/* 로그인 전 이미지 */}
      <img
        className="user-pic"
        src="//file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
        alt="로그인 전- 아이콘"
      />
      <input
        onClick={checkLogin}
        className="input-comment"
        type="text"
        placeholder={t("please_login")}
        readOnly={true}
      />
    </div>
  ) : type === "reply" ? (
    <div className="top-comment">
      {/* 댓글달기 */}
      <img
        className="user-pic"
        src="//file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
        alt="로그인 전- 아이콘"
      />
      <input
        onClick={openModal}
        className="input-comment"
        type="text"
        placeholder={t("Please_leave_a_reply")}
        readOnly={true}
      />
    </div>
  ) : type === "content" ? (
    <div className="top-comment">
      <img
        className="user-pic"
        src="//file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
        alt="로그인 전- 아이콘"
      />
      <input
        onClick={openModal}
        className="input-comment"
        type="text"
        placeholder={`[${userNickname === "" ? userId : userNickname}] ${t(
          "would_you_like_to_publish_this_post"
        )}`}
        readOnly={true}
      />
    </div>
  ) : type === "privacyAgree" ? (
    <div className="top-comment">
      {/* 로그인 전 이미지 */}
      <img
        className="user-pic"
        src="//file.valofe.com/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
        alt="로그인 전- 아이콘"
      />
      <input
        onClick={naverAuthorizeCheck}
        className="input-comment"
        type="text"
        placeholder={t("need_agreement_to_terms")}
        readOnly={true}
      />
    </div>
  ) : null;
}

export default withTranslation()(CommonInput);
